import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'baseline',
  },
  header: {
    fontSize: '0.75rem',
    height: '16px',
    padding: 0,
  },
  value: {
    fontSize: '0.875rem',
    height: '24px',
    marginTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
  },
}));

export default useStyles;
